import { api } from '../api';

type CreateOrganizationRequest = {
  organization: {
    name: string;
    url: string;
    isOwnOrganization: boolean;
  };
};

type CreateOrganizationResponse = {
  id: string;
  name: string;
  url: string;
  isOwnOrganization: boolean;
};

const extendedApi = api.injectEndpoints({
  endpoints: (build) => ({
    createOrganization: build.mutation<
      CreateOrganizationResponse,
      CreateOrganizationRequest
    >({
      query: ({ organization }) => ({
        url: 'organizations',
        method: 'POST',
        body: organization,
      }),
    }),
  }),
});

export const { useCreateOrganizationMutation } = extendedApi;
